import type { SelectOption } from '@fourthwall/components'

import { CATEGORIES } from './consts'

export const getCategorySelectOptions = () => {
  return CATEGORIES.reduce((acc, category) => {
    const categoryOption = {
      label: category.label,
      value: category.label,
      key: category.label,
    }

    const subcategories = category.subcategories?.map((subcategory) => ({
      label: `${category.label} - ${subcategory}`,
      value: `${category.label} - ${subcategory}`,
      key: subcategory,
    }))

    acc.push(categoryOption)

    if (subcategories) {
      subcategories.forEach((subcategoryOption) => {
        acc.push(subcategoryOption)
      })
    }

    return acc
  }, [] as SelectOption[])
}

export const getCategoryAndSubcategoryFromSelectedCategory = (category: string) => {
  const categoryAndSubcategory = category.split(' - ')

  return {
    category: categoryAndSubcategory[0],
    subcategory: categoryAndSubcategory[1],
  }
}
